import { Box, Grid, Typography } from "@mui/material";

export default function Terms({ lessThanXL }) {
  return (
    <>
      <Box
        sx={{
          color: "#1F1F1F",
          paddingLeft: !lessThanXL ? "70px" : "21px",
          paddingRight: !lessThanXL ? "70px" : "21px",
        }}
      >
        <Grid mt={12} container>
          <Grid item md={12}>
            <Typography
              sx={{
                fontSize: "28px",
              }}
              variant="h4"
              lineHeight={"normal"}
              fontWeight="700"
              gutterBottom
            >
              TERMS OF USE
            </Typography>
            <br />
            1. Agreement to terms These Terms of Service constitute a legally
            binding agreement made between you, whether personally or on behalf
            of an entity ("you") and Cognitiva Sp. z o.o. ("Company", "we",
            "us", or "our"), concerning your access to and use of the
            https://www.alicechat.ai website as well as any other media form,
            media channel, mobile website or mobile application related, linked,
            or otherwise connected thereto (collectively, the "Site"). We are
            registered in Poland, and have our registered office at Pulawska
            472, 02-884 Warsaw, Poland. You agree that by accessing the Site,
            you have read, understood, and agree to be bound by all of these
            Terms of Service. IF YOU DO NOT AGREE WITH ALL OF THESE TERMS OF
            SERVICE, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SITE AND
            YOU MUST DISCONTINUE USE IMMEDIATELY. Supplemental terms and
            conditions or documents that may be posted on the Site from time to
            time are hereby expressly incorporated herein by reference. We
            reserve the right, in our sole discretion, to make changes or
            modifications to these Terms of Service from time to time. We will
            alert you about any changes by updating the "Last updated" date of
            these Terms of Service, and you waive any right to receive specific
            notice of each such change. Please ensure that you check the
            applicable Terms every time you use our Site so that you understand
            which Terms apply. You will be subject to, and will be deemed to
            have been made aware of and to have accepted, the changes in any
            revised Terms of Service by your continued use of the Site after the
            date such revised Terms of Service are posted. The information
            provided on the Site is not intended for distribution to or use by
            any person or entity in any jurisdiction or country where such
            distribution or use would be contrary to law or regulation or which
            would subject us to any registration requirement within such
            jurisdiction or country. Accordingly, those persons who choose to
            access the Site from other locations do so on their own initiative
            and are solely responsible for compliance with local laws, if and to
            the extent local laws are applicable. The Site is intended for users
            who are at least 18 years old. Persons under the age of 18 are not
            permitted to use or register for the Site.
            <br /> <br />
            2. Intellectual property rights Unless otherwise indicated, the Site
            is our proprietary property and all source code, databases,
            functionality, software, website designs, audio, video, text,
            photographs, and graphics on the Site (collectively, the "Content")
            and the trademarks, service marks, and logos contained therein (the
            "Marks") are owned or controlled by us or licensed to us, and are
            protected by copyright and trademark laws and various other
            intellectual property rights and unfair competition laws of the
            Poland, international copyright laws, and international conventions.
            The Content and the Marks are provided on the Site "AS IS" for your
            information and personal use only. Except as expressly provided in
            these Terms of Service, no part of the Site and no Content or Marks
            may be copied, reproduced, aggregated, republished, uploaded,
            posted, publicly displayed, encoded, translated, transmitted,
            distributed, sold, licensed, or otherwise exploited for any
            commercial purpose whatsoever, without our express prior written
            permission. Provided that you are eligible to use the Site, you are
            granted a limited license to access and use the Site and to download
            or print a copy of any portion of the Content to which you have
            properly gained access solely for your personal, non-commercial use.
            We reserve all rights not expressly granted to you in and to the
            Site, the Content and the Marks.
            <br /> <br />
            3. User representations By using the Site, you represent and warrant
            that: (1) all information you submit will be true, accurate,
            current, and complete; (2) you will maintain the accuracy of such
            information and promptly update such registration information as
            necessary; (3) you have the legal capacity and you agree to comply
            with these Terms of Service; (4) you are not a minor in the
            jurisdiction in which you reside; (5) you will not access the Site
            through automated or non-human means, whether through a bot, script
            or otherwise; (6) you will not use the Site for any illegal or
            unauthorized purpose; and (7) your use of the Site will not violate
            any applicable law or regulation.
            <br /> <br />
            4. Software We may include software for use in connection with our
            services. If such software is accompanied by an end user license
            agreement ("EULA"), the terms of the EULA will govern your use of
            the software. If such software is not accompanied by a EULA, then we
            grant to you a non-exclusive, revocable, personal, and
            non-transferable license to use such software solely in connection
            with our services and in accordance with these Terms of Service. Any
            Software and any related documentation is provided "as is" without
            warranty of any kind, either express or implied, including, without
            limitation, the implied warranties of merchantability, fitness for a
            particular purpose, or non-infringement. You accept any and all risk
            arising out of use or performance of any Software. You may not
            reproduce or redistribute any software except in accordance with the
            EULA or these Terms of Service.
            <br /> <br />
            5. Prohibited activities You may not
            access or use the Site for any purpose other than that for which we
            make the Site available. The Site may not be used in connection with
            any commercial endeavors except those that are specifically endorsed
            or approved by us. As a user of the Site, you agree not to: -
            Systematically retrieve data or other content from the Site to
            create or compile, directly or indirectly, a collection,
            compilation, database, or directory without written permission from
            us. - - - Trick, defraud, or mislead us and other users, especially
            in any attempt to learn sensitive information. - Circumvent,
            disable, or otherwise interfere with security-related features of
            the Site, including features that prevent or restrict the use or
            copying of any Content or enforce limitations on the use of the Site
            and/or the Content contained therein. - Disparage, tarnish, or
            otherwise harm, in our opinion, us and/or the Site. - Use any
            information obtained from the Site in order to harass, abuse, or
            harm another person. - Make improper use of our support services or
            submit false reports of abuse or misconduct. - Use the Site in a
            manner inconsistent with any applicable laws or regulations. -
            Engage in unauthorized framing of or linking to the Site. - Upload
            or transmit (or attempt to upload or to transmit) viruses, Trojan
            horses, or other material, including excessive use of capital
            letters and spamming (continuous posting of repetitive text), that
            interferes with any party's uninterrupted use and enjoyment of the
            Site or modifies, impairs, disrupts, alters, or interferes with the
            use, features, functions, operation, or maintenance of the Site. -
            Engage in any automated use of the system, such as using scripts to
            send comments or messages, or using any data mining, robots, or
            similar data gathering and extraction tools. - Delete the copyright
            or other proprietary rights notice from any Content. - Attempt to
            impersonate another user or person or use the username of another
            user. - Upload or transmit (or attempt to upload or to transmit) any
            material that acts as a passive or active information collection or
            transmission mechanism, including without limitation, clear graphics
            interchange formats ("gifs"), 1 x1 pixels, web bugs, cookies, or
            other similar devices (sometimes referred to as "spyware" or
            "passive collection mechanisms" or "pcms"). - Interfere with,
            disrupt, or create an undue burden on the Site or the networks or
            services connected to the Site. - Harass, annoy, intimidate, or
            threaten any of our employees or agents engaged in providing any
            portion of the Site to you. - Attempt to bypass any measures of the
            Site designed to prevent or restrict access to the Site, or any
            portion of the Site. - Copy or adapt the Site's software, including
            but not limited to Python, HTML, JavaScript, or other code. - Except
            as permitted by applicable law, decipher, decompile, disassemble, or
            reverse engineer any of the software comprising or in any way making
            up a part of the Site. - Except as may be the result of standard
            search engine or Internet browser usage, use, launch, develop, or
            distribute any automated system, including without limitation, any
            spider, robot, cheat utility, scraper, or offline reader that
            accesses the Site, or using or launching any unauthorized script or
            other software. - Use a buying agent or purchasing agent to make
            purchases on the Site. - Use the Site as part of any effort to
            compete with us or otherwise use the Site and/or the Content for any
            revenue-generating endeavor or commercial enterprise. 
            <br /> <br />
            6. User
            generated contributions The Site may invite you to chat, contribute
            to, or participate in blogs, message boards, online forums, and
            other functionality, and may provide you with the opportunity to
            create, submit, post, display, transmit, perform, publish,
            distribute, or broadcast content and materials to us or on the Site,
            including but not limited to text, writings, video, audio,
            photographs, graphics, comments, suggestions, or personal
            information or other material (collectively, "Contributions").
            Contributions may be viewable by other users of the Site and through
            third-party websites. As such, any Contributions you transmit may be
            treated as non-confidential and non-proprietary. When you create or
            make available any Contributions, you thereby represent and warrant
            that: - The creation, distribution, transmission, public display, or
            performance, and the accessing, downloading, or copying of your
            Contributions do not and will not infringe the proprietary rights,
            including but not limited to the copyright, patent, trademark, trade
            secret, or moral rights of any third party. - You are the creator
            and owner of or have the necessary licenses, rights, consents,
            releases, and permissions to use and to authorize us, the Site, and
            other users of the Site to use your Contributions in any manner
            contemplated by the Site and these Terms of Service. - You have the
            written consent, release, and/or permission of each and every
            identifiable individual person in your Contributions to use the name
            or likeness of each and every such identifiable individual person to
            enable inclusion and use of your Contributions in any manner
            contemplated by the Site and these Terms of Service. - Your
            Contributions are not false, inaccurate, or misleading. - Your
            Contributions are not unsolicited or unauthorized advertising,
            promotional materials, pyramid schemes, chain letters, spam, mass
            mailings, or other forms of solicitation. - Your Contributions are
            not obscene, lewd, lascivious, filthy, violent, harassing, libelous,
            slanderous, or otherwise objectionable (as determined by us). - Your
            Contributions do not ridicule, mock, disparage, intimidate, or abuse
            anyone. - Your Contributions are not used to harass or threaten (in
            the legal sense of those terms) any other person and to promote
            violence against a specific person or class of people. - Your
            Contributions do not violate any applicable law, regulation, or
            rule. - Your Contributions do not violate the privacy or publicity
            rights of any third party. - Your Contributions do not violate any
            applicable law concerning child pornography, or otherwise intended
            to protect the health or well-being of minors. - Your Contributions
            do not include any offensive comments that are connected to race,
            national origin, gender, sexual preference, or physical handicap. -
            Your Contributions do not otherwise violate, or link to material
            that violates, any provision of these Terms of Service, or any
            applicable law or regulation. Any use of the Site in violation of
            the foregoing violates these Terms of Service and may result in,
            among other things, termination or suspension of your rights to use
            the Site. 
            <br /> <br />
            7. Contribution License By posting your Contributions to
            any part of the Site, you automatically grant, and you represent and
            warrant that you have the right to grant, to us an unrestricted,
            unlimited, irrevocable, perpetual, non-exclusive, transferable,
            royalty-free, fully-paid, worldwide right, and license to host, use,
            copy, reproduce, disclose, sell, resell, publish, broadcast,
            retitle, archive, store, cache, publicly perform, publicly display,
            reformat, translate, transmit, excerpt (in whole or in part), and
            distribute such Contributions (including, without limitation, your
            image and voice) for any purpose, commercial, advertising, or
            otherwise, and to prepare derivative works of, or incorporate into
            other works, such Contributions, and grant and authorize sublicenses
            of the foregoing. The use and distribution may occur in any media
            formats and through any media channels. This license will apply to
            any form, media, or technology now known or hereafter developed, and
            includes our use of your name, company name, and franchise name, as
            applicable, and any of the trademarks, service marks, trade names,
            logos, and personal and commercial images you provide. You waive all
            moral rights in your Contributions, and you warrant that moral
            rights have not otherwise been asserted in your Contributions. We do
            not assert any ownership over your Contributions. You retain full
            ownership of all of your Contributions and any intellectual property
            rights or other proprietary rights associated with your
            Contributions. We are not liable for any statements or
            representations in your Contributions provided by you in any area on
            the Site. You are solely responsible for your Contributions to the
            Site and you expressly agree to exonerate us from any and all
            responsibility and to refrain from any legal action against us
            regarding your Contributions. We have the right, in our sole and
            absolute discretion, (1) to edit, redact, or otherwise change any
            Contributions; (2) to re-categorize any Contributions to place them
            in more appropriate locations on the Site; and (3) to pre-screen or
            delete any Contributions at any time and for any reason, without
            notice. We have no obligation to monitor your Contributions. 
            <br /> <br />
            8.
            Submissions You acknowledge and agree that any questions, comments,
            suggestions, ideas, feedback, or other information regarding the
            Site ("Submissions") provided by you to us are non-confidential and
            shall become our sole property. We shall own exclusive rights,
            including all intellectual property rights, and shall be entitled to
            the unrestricted use and dissemination of these Submissions for any
            lawful purpose, commercial or otherwise, without acknowledgment or
            compensation to you. You hereby waive all moral rights to any such
            Submissions, and you hereby warrant that any such Submissions are
            original with you or that you have the right to submit such
            Submissions. You agree there shall be no recourse against us for any
            alleged or actual infringement or misappropriation of any
            proprietary right in your Submissions. 
            <br /> <br />
            9. Third-party websites and
            content The Site may contain (or you may be sent via the Site) links
            to other websites ("Third-Party Websites") as well as articles,
            photographs, text, graphics, pictures, designs, music, sound, video,
            information, applications, software, and other content or items
            belonging to or originating from third parties ("Third-Party
            Content"). Such Third-Party Websites and Third-Party Content are not
            investigated, monitored, or checked for accuracy, appropriateness,
            or completeness by us, and we are not responsible for any
            Third-Party Websites accessed through the Site or any Third-Party
            Content posted on, available through, or installed from the Site,
            including the content, accuracy, offensiveness, opinions,
            reliability, privacy practices, or other policies of or contained in
            the Third-Party Websites or the Third-Party Content. Inclusion of,
            linking to, or permitting the use or installation of any Third-Party
            Websites or any Third-Party Content does not imply approval or
            endorsement thereof by us. If you decide to leave the Site and
            access the Third-Party Websites or to use or install any Third-Party
            Content, you do so at your own risk, and you should be aware these
            Terms of Service no longer govern. You should review the applicable
            terms and policies, including privacy and data gathering practices,
            of any website to which you navigate from the Site or relating to
            any applications you use or install from the Site. Any purchases you
            make through Third-Party Websites will be through other websites and
            from other companies, and we take no responsibility whatsoever in
            relation to such purchases which are exclusively between you and the
            applicable third party. You agree and acknowledge that we do not
            endorse the products or services offered on Third-Party Websites and
            you shall hold us harmless from any harm caused by your purchase of
            such products or services. Additionally, you shall hold us harmless
            from any losses sustained by you or harm caused to you relating to
            or resulting in any way from any Third-Party Content or any contact
            with Third-Party Websites. 
            <br /> <br />
            10. Site Management We reserve the right,
            but not the obligation, to: (1) monitor the Site for violations of
            these Terms of Service; (2) take appropriate legal action against
            anyone who, in our sole discretion, violates the law or these Terms
            of Service, including without limitation, reporting such user to law
            enforcement authorities; (3) in our sole discretion and without
            limitation, refuse, restrict access to, limit the availability of,
            or disable (to the extent technologically feasible) any of your
            Contributions or any portion thereof; (4) in our sole discretion and
            without limitation, notice, or liability, to remove from the Site or
            otherwise disable all files and content that are excessive in size
            or are in any way burdensome to our systems; and (5) otherwise
            manage the Site in a manner designed to protect our rights and
            property and to facilitate the proper functioning of the Site. 
            <br /> <br />
            11.
            Privacy Policy z We care about data privacy and security. Please
            review our Privacy Policy. By using the Site, you agree to be bound
            by our Privacy Policy, which is incorporated into these Terms of
            Service. Please be advised the Site is hosted in Poland and in the
            United States. If you access the Site from any other region of the
            world with laws or other requirements governing personal data
            collection, use, or disclosure that differ from applicable laws in
            the Poland, then through your continued use of the Site, you are
            transferring your data to the Poland and in the United States, and
            you agree to have your data transferred to and processed in the
            Poland and in the United States. 
            <br /> <br />
            12. Copyright infringements We
            respect the intellectual property rights of others. If you believe
            that any material available on or through the Site infringes upon
            any copyright you own or control, please immediately notify us using
            the contact information provided below (a "Notification"). A copy of
            your Notification will be sent to the person who posted or stored
            the material addressed in the Notification. Please be advised that
            pursuant to applicable law you may be held liable for damages if you
            make material misrepresentations in a Notification. Thus, if you are
            not sure that material located on or linked to by the Site infringes
            your copyright, you should consider first contacting an attorney.
           
            <br /> <br />
            13. Term and termination These Terms of Service shall remain in full
            force and effect while you use the Site. WITHOUT LIMITING ANY OTHER
            PROVISION OF THESE TERMS OF SERVICE, WE RESERVE THE RIGHT TO, IN OUR
            SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND
            USE OF THE SITE (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY
            PERSON FOR ANY REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION
            FOR BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN
            THESE TERMS OF SERVICE OR OF ANY APPLICABLE LAW OR REGULATION. WE
            MAY TERMINATE YOUR USE OR PARTICIPATION IN THE SITE OR DELETE ANY
            CONTENT OR INFORMATION THAT YOU POSTED AT ANY TIME, WITHOUT WARNING,
            IN OUR SOLE DISCRETION. 
            <br /> <br />
            14. Modifications and interruptions We
            reserve the right to change, modify, or remove the contents of the
            Site at any time or for any reason at our sole discretion without
            notice. However, we have no obligation to update any information on
            our Site. We also reserve the right to modify or discontinue all or
            part of the Site without notice at any time. We will not be liable
            to you or any third party for any modification, price change,
            suspension, or discontinuance of the Site. We cannot guarantee the
            Site will be available at all times. We may experience hardware,
            software, or other problems or need to perform maintenance related
            to the Site, resulting in interruptions, delays, or errors. We
            reserve the right to change, revise, update, suspend, discontinue,
            or otherwise modify the Site at any time or for any reason without
            notice to you. You agree that we have no liability whatsoever for
            any loss, damage, or inconvenience caused by your inability to
            access or use the Site during any downtime or discontinuance of the
            Site. Nothing in these Terms of Service will be construed to
            obligate us to maintain and support the Site or to supply any
            corrections, updates, or releases in connection therewith. 
            <br /> <br />
            15.
            Governing law These Terms of Service and your use of the Site are
            governed by and construed in accordance with the laws of Poland
            applicable to agreements made and to be entirely performed within
            Poland, without regard to its conflict of law principles. 
            <br /> <br />
            16.
            Dispute resolution Informal Negotiations To expedite resolution and
            control the cost of any dispute, controversy, or claim related to
            these Terms of Service (each "Dispute" and collectively, the
            "Disputes") brought by either you or us (individually, a "Party" and
            collectively, the "Parties"), the Parties agree to first attempt to
            negotiate any Dispute (except those Disputes expressly provided
            below) informally for at least thirty (30) days before initiating
            arbitration. Such informal negotiations commence upon written notice
            from one Party to the other Party. Binding Arbitration If the
            Parties are unable to resolve a Dispute through informal
            negotiations, the Dispute (except those Disputes expressly excluded
            below) will be finally and exclusively resolved by binding
            arbitration. YOU UNDERSTAND THAT WITHOUT THIS PROVISION, YOU WOULD
            HAVE THE RIGHT TO SUE IN COURT. The arbitration shall be commenced
            and conducted under the The Court of Arbitration at the Polish
            Chamber of Commerce, on the basis of the UNCITRAL Rules of
            Arbitration. The arbitration may be conducted in person, through the
            submission of documents, by phone, or online. The arbitrator will
            make a decision in writing, but need not provide a statement of
            reasons unless requested by either Party. The arbitrator must follow
            applicable law, and any award may be challenged if the arbitrator
            fails to do so. Except where otherwise required by the applicable
            UNCITRAL Rules of Arbitration or applicable law, the arbitration
            will take place in Warsaw, Poland. Except as otherwise provided
            herein, the Parties may litigate in court to compel arbitration,
            stay proceedings pending arbitration, or to confirm, modify, vacate,
            or enter judgment on the award entered by the arbitrator. If for any
            reason, a Dispute proceeds in court rather than arbitration, the
            Dispute shall be commenced or prosecuted in the Court of Arbitration
            at the Polish Chamber of Commerce in Warsaw, Poland, and the Parties
            hereby consent to, and waive all defenses of lack of personal
            jurisdiction, and forum non conveniens with respect to venue and
            jurisdiction in such court. Termly Policy In no event shall any
            Dispute brought by either Party related in any way to the Site be
            commenced more than one (1) years after the cause of action arose.
            If this provision is found to be illegal or unenforceable, then
            neither Party will elect to arbitrate any Dispute falling within
            that portion of this provision found to be illegal or unenforceable
            and such Dispute shall be decided by a court of competent
            jurisdiction within the courts listed for jurisdiction above, and
            the Parties agree to submit to the personal jurisdiction of that
            court. Restrictions The Parties agree that any arbitration shall be
            limited to the Dispute between the Parties individually. To the full
            extent permitted by law, (a) no arbitration shall be joined with any
            other proceeding; (b) there is no right or authority for any Dispute
            to be arbitrated on a class-action basis or to utilize class action
            procedures; and (c) there is no right or authority for any Dispute
            to be brought in a purported representative capacity on behalf of
            the general public or any other persons. Exceptions to Informal
            Negotiations and Arbitration The Parties agree that the following
            Disputes are not subject to the above provisions concerning informal
            negotiations and binding arbitration: (a) any Disputes seeking to
            enforce or protect, or concerning the validity of, any of the
            intellectual property rights of a Party; (b) any Dispute related to,
            or arising from, allegations of theft, piracy, invasion of privacy,
            or unauthorized use; and (c) any claim for injunctive relief. If
            this provision is found to be illegal or unenforceable, then neither
            Party will elect to arbitrate any Dispute falling within that
            portion of this provision found to be illegal or unenforceable and
            such Dispute shall be decided by a court of competent jurisdiction
            within the courts listed for jurisdiction above, and the Parties
            agree to submit to the personal jurisdiction of that court. 
            <br /> <br />
            17.
            Corrections There may be information on the Site that contains
            typographical errors, inaccuracies, or omissions, including
            descriptions, pricing, availability, and various other information.
            We reserve the right to correct any errors, inaccuracies, or
            omissions and to change or update the information on the Site at any
            time, without prior notice. 
            <br /> <br />
            18. Disclaimer THE SITE IS PROVIDED ON
            AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE THAT YOUR USE OF THE SITE
            AND OUR SERVICES WILL BE AT YOUR SOLE RISK. TO THE FULLEST EXTENT
            PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN
            CONNECTION WITH THE SITE AND YOUR USE THEREOF, INCLUDING, WITHOUT
            LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR
            REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE SITE'S
            CONTENT OR THE CONTENT OF ANY WEBSITES LINKED TO THE SITE AND WE
            WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (1) ERRORS,
            MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, (2) PERSONAL
            INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM
            YOUR ACCESS TO AND USE OF THE SITE, (3) ANY UNAUTHORIZED ACCESS TO
            OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION
            AND/OR FINANCIAL INFORMATION STORED THEREIN, (4) ANY INTERRUPTION OR
            CESSATION OF TRANSMISSION TO OR FROM THE SITE, (5) ANY BUGS,
            VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR
            THROUGH THE SITE BY ANY THIRD PARTY, AND/OR (6) ANY ERRORS OR
            OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR DAMAGE OF
            ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED,
            TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SITE. WE DO NOT
            WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY
            PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH
            THE SITE, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE
            APPLICATION FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND WE WILL
            NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY
            TRANSACTION BETWEEN YOU AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR
            SERVICES. AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY
            MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND
            EXERCISE CAUTION WHERE APPROPRIATE. 
            <br /> <br />
            19. Limitations of liability IN
            NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO
            YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL,
            EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST
            PROFIT, LOST REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM
            YOUR USE OF THE SITE, EVEN IF WE HAVE BEEN ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGES. NOTWITHSTANDING ANYTHING TO THE
            CONTRARY CONTAINED HEREIN, OUR LIABILITY TO YOU FOR ANY CAUSE
            WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION, WILL AT ALL
            TIMES BE LIMITED TO $100.00 USD. CERTAIN US STATE LAWS AND
            INTERNATIONAL LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR
            THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY
            TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS OR LIMITATIONS MAY NOT
            APPLY TO YOU, AND YOU MAY HAVE ADDITIONAL RIGHTS. 19.
            Indemnification You agree to defend, indemnify, and hold us
            harmless, including our subsidiaries, affiliates, and all of our
            respective officers, agents, partners, and employees, from and
            against any loss, damage, liability, claim, or demand, including
            reasonable attorneys' fees and expenses, made by any third party due
            to or arising out of: (1) your Contributions; (2) use of the Site;
            (3) breach of these Terms of Service; (4) any breach of your
            representations and warranties set forth in these Terms of Service;
            (5) your violation of the rights of a third party, including but not
            limited to intellectual property rights; or (6) any overt harmful
            act toward any other user of the Site with whom you connected via
            the Site. Notwithstanding the foregoing, we reserve the right, at
            your expense, to assume the exclusive defense and control of any
            matter for which you are required to indemnify us, and you agree to
            cooperate, at your expense, with our defense of such claims. We will
            use reasonable efforts to notify you of any such claim, action, or
            proceeding which is subject to this indemnification upon becoming
            aware of it. 
            <br /> <br />
            20. User data We will maintain certain data that you
            transmit to the Site for the purpose of managing the performance of
            the Site, as well as data relating to your use of the Site. Although
            we perform regular routine backups of data, you are solely
            responsible for all data that you transmit or that relates to any
            activity you have undertaken using the Site. You agree that we shall
            have no liability to you for any loss or corruption of any such
            data, and you hereby waive any right of action against us arising
            from any such loss or corruption of such data. 
            <br /> <br />
            21. Data
            Anonymization We reserve the right to anonymize user data when
            appropriate and in accordance with applicable data protection laws.
            Anonymized data is information that has been modified so that it can
            no longer be associated with an identifiable individual, either
            directly or indirectly. Such data may be retained and processed
            indefinitely for internal research, analytics, product improvement,
            statistical or service optimization purposes. Once anonymized, the
            data is no longer considered personal information and is excluded
            from any rights to access, deletion, or correction granted under
            applicable data protection regulations. 
            <br /> <br />
            22. Electronic
            communications, transactions, and signatures Visiting the Site,
            sending us emails, and completing online forms constitute electronic
            communications. You consent to receive electronic communications,
            and you agree that all agreements, notices, disclosures, and other
            communications we provide to you electronically, via email and on
            the Site, satisfy any legal requirement that such communication be
            in writing. YOU HEREBY AGREE TO THE USE OF ELECTRONIC SIGNATURES,
            CONTRACTS, ORDERS, AND OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF
            NOTICES, POLICIES, AND RECORDS OF TRANSACTIONS INITIATED OR
            COMPLETED BY US OR VIA THE SITE. You hereby waive any rights or
            requirements under any statutes, regulations, rules, ordinances, or
            other laws in any jurisdiction which require an original signature
            or delivery or retention of non-electronic records, or to payments
            or the granting of credits by any means other than electronic means.
            <br /> <br />

            23. Miscellaneous These Terms of Service and any policies or
            operating rules posted by us on the Site or in respect to the Site
            constitute the entire agreement and understanding between you and
            us. Our failure to exercise or enforce any right or provision of
            these Terms of Service shall not operate as a waiver of such right
            or provision. These Terms of Service operate to the fullest extent
            permissible by law. We may assign any or all of our rights and
            obligations to others at any time. We shall not be responsible or
            liable for any loss, damage, delay, or failure to act caused by any
            cause beyond our reasonable control. If any provision or part of a
            provision of these Terms of Service is determined to be unlawful,
            void, or unenforceable, that provision or part of the provision is
            deemed severable from these Terms of Service and does not affect the
            validity and enforceability of any remaining provisions. There is no
            joint venture, partnership, employment or agency relationship
            created between you and us as a result of these Terms of Service or
            use of the Site. You agree that these Terms of Service will not be
            construed against us by virtue of having drafted them. You hereby
            waive any and all defenses you may have based on the electronic form
            of these Terms of Service and the lack of signing by the parties
            hereto to execute these Terms of Service. 
            <br /> <br />
            24. Contact us In order to
            resolve a complaint regarding the Site or to receive further
            information regarding use of the Site, please contact us at:
            Cognitiva Sp. z o.o. Pulawska 472, Warsaw Poland hello@cognitiva.dev
            PRIVACY POLICY This privacy notice for Cognitiva Sp. z o.o.
            ("Company," "we," "us," or "our"), describes how and why we might
            collect, store, use, and/or share ("process") your information when
            you use our services ("Services"), such as when you: Visit our
            website at https://www.alicechat.ai, or any website of ours that
            links to this privacy notice Engage with us in other related ways,
            including any sales, marketing, or events Reading this privacy
            notice will help you understand your privacy rights and choices. If
            you do not agree with our policies and practices, please do not use
            our Services. Summary of key points This summary provides key points
            from our privacy notice, but you can find out more details about any
            of these topics by clicking the link following each key point or by
            using our table of contents below to find the section you are
            looking for. What personal information do we process? When you
            visit, use, or navigate our Services, we may process personal
            information depending on how you interact with Cognitiva Sp. z o.o.
            and the Services, the choices you make, and the products and
            features you use. Do we process any sensitive personal information?
            We may process sensitive personal information when necessary. Do we
            receive any information from third parties? We do not receive any
            information from third parties. How do we process your information?
            We process your information to provide, improve, and administer our
            Services, communicate with you, for security and fraud prevention,
            and to comply with law. We may also process your information for
            other purposes with your consent. We process your information only
            when we have a valid legal reason to do so. How do we keep your
            information safe? We have organizational and technical processes and
            procedures in place to protect your personal information. However,
            no electronic transmission over the internet or information storage
            technology can be guaranteed to be 100% secure, so we cannot promise
            or guarantee that hackers, cybercriminals, or other unauthorized
            third parties will not be able to defeat our security and improperly
            collect, access, steal, or modify your information. What are your
            rights? Depending on where you are located geographically, the
            applicable privacy law may mean you have certain rights regarding
            your personal information. How do you exercise your rights? The
            easiest way to exercise your rights is by filling out our data
            subject request by contacting us. We will consider and act upon any
            request in accordance with applicable data protection laws. 1. What
            information do we collect? Personal information you disclose to us
            We collect personal information that you provide to us. We collect
            personal information that you voluntarily provide to us when you
            express an interest in obtaining information about us or our
            products and Services, when you participate in activities on the
            Services, or otherwise when you contact us. Personal Information
            Provided by You. The personal information that we collect depends on
            the context of your interactions with us and the Services, the
            choices you make, and the products and features you use. The
            personal information we collect may include the following: names
            email addresses Sensitive Information. When necessary, with your
            consent or as otherwise permitted by applicable law, we process the
            following categories of sensitive information revealing race or
            ethnic origin. Information automatically collected Some information
            — such as your Internet Protocol (IP) address and/or browser and
            device characteristics — is collected automatically when you visit
            our Services. We automatically collect certain information when you
            visit, use, or navigate the Services. This information does not
            reveal your specific identity (like your name or contact
            information) but may include device and usage information, such as
            your IP address, browser and device characteristics, operating
            system, language preferences, referring URLs, device name, country,
            location, information about how and when you use our Services, and
            other technical information. This information is primarily needed to
            maintain the security and operation of our Services, and for our
            internal analytics and reporting purposes. Like many businesses, we
            also collect information through cookies and similar technologies.
            The information we collect includes: Log and Usage Data. Log and
            usage data is service-related, diagnostic, usage, and performance
            information our servers automatically collect when you access or use
            our Services and which we record in log files. Depending on how you
            interact with us, this log data may include your IP address, device
            information, browser type, and settings and information about your
            activity in the Services (such as the date/time stamps associated
            with your usage, pages and files viewed, searches, and other actions
            you take such as which features you use), device event information
            (such as system activity, error reports, and hardware settings).
            Device Data. We collect device data such as information about your
            computer, phone, tablet, or other device you use to access the
            Services. Depending on the device used, this device data may include
            information such as your IP address (or proxy server), device and
            application identification numbers, location, browser type, hardware
            model, Internet service provider and/or mobile carrier, operating
            system, and system configuration information. Location Data. We
            collect location data such as information about your device's
            location, which can be either precise or imprecise. How much
            information we collect depends on the type and settings of the
            device you use to access the Services. For example, we may use GPS
            and other technologies to collect geolocation data that tells us
            your current location (based on your IP address). You can opt out of
            allowing us to collect this information either by refusing access to
            the information or by disabling your Location setting on your
            device. However, if you choose to opt out, you may not be able to
            use certain aspects of the Services. Conversation transcripts. We
            collect text data and voice recording data that is transcribed into
            text when you interact with the Services. 2. How do we process your
            personal information? We process your information to provide,
            improve, and administer our Services, communicate with you, for
            security and fraud prevention, and to comply with law. We may also
            process your information for other purposes with your consent. We
            process your personal information for a variety of reasons,
            depending on how you interact with our Services, including:. To
            deliver and facilitate delivery of services to the user. We may
            process your information to provide you with the requested service.
            To request feedback. We may process your information when necessary
            to request feedback and to contact you about your use of our
            Services. To send you marketing and promotional communications. We
            may process the personal information you send to us for our
            marketing purposes, if this is in accordance with your marketing
            preferences. You can opt out of our marketing emails at any time. To
            protect our Services. We may process your information as part of our
            efforts to keep our Services safe and secure, including fraud
            monitoring and prevention. To identify usage trends. We may process
            information about how you use our Services to better understand how
            they are being used so we can improve them. To determine the
            effectiveness of our marketing and promotional campaigns. We may
            process your information to better understand how to provide
            marketing and promotional campaigns that are most relevant to you.
            To save or protect an individual's vital interest. We may process
            your information when necessary to save or protect an individual's
            vital interest, such as to prevent harm. 3. What legal bases do we
            rely on to process your information? We only process your personal
            information when we believe it is necessary and we have a valid
            legal reason (i.e., legal basis) to do so under applicable law, like
            with your consent, to comply with laws, to provide you with services
            to enter into or fulfill our contractual obligations, to protect
            your rights, or to fulfill our legitimate business interests. If you
            are located in the EU or UK, this section applies to you. The
            General Data Protection Regulation (GDPR) and UK GDPR require us to
            explain the valid legal bases we rely on in order to process your
            personal information. As such, we may rely on the following legal
            bases to process your personal information: Consent. We may process
            your information if you have given us permission (i.e., consent) to
            use your personal information for a specific purpose. You can
            withdraw your consent at any time. Performance of a Contract. We may
            process your personal information when we believe it is necessary to
            fulfill our contractual obligations to you, including providing our
            Services or at your request prior to entering into a contract with
            you. Legitimate Interests. We may process your information when we
            believe it is reasonably necessary to achieve our legitimate
            business interests and those interests do not outweigh your
            interests and fundamental rights and freedoms. For example, we may
            process your personal information for some of the purposes described
            in order to: Send users information about special offers and
            discounts on our products and services Analyze how our services are
            used so we can improve them to engage and retain users Support our
            marketing activities Diagnose problems and/or prevent fraudulent
            activities Understand how our users use our products and services so
            we can improve user experience Legal Obligations. We may process
            your information where we believe it is necessary for compliance
            with our legal obligations, such as to cooperate with a law
            enforcement body or regulatory agency, exercise or defend our legal
            rights, or disclose your information as evidence in litigation in
            which we are involved. Vital Interests. We may process your
            information where we believe it is necessary to protect your vital
            interests or the vital interests of a third party, such as
            situations involving potential threats to the safety of any person.
            4. When and with whom do we share your personal information? We may
            share information in specific situations described in this section
            and/or with the following categories of third parties. Vendors,
            Consultants, and Other Third-Party Service Providers. We may share
            your data with third-party vendors, service providers, contractors,
            or agents ("third parties") who perform services for us or on our
            behalf and require access to such information to do that work. We
            have contracts in place with our third parties, which are designed
            to help safeguard your personal information. This means that they
            cannot do anything with your personal information unless we have
            instructed them to do it. They will also not share your personal
            information with any organization apart from us. They also commit to
            protect the data they hold on our behalf and to retain it for the
            period we instruct. The categories of third parties we may share
            personal information with are as follows: Cloud Computing Services
            Data Analytics Services Website Hosting Service Providers AI
            Consulting Providers We also may need to share your personal
            information in the following situations: Business Transfers. We may
            share or transfer your information in connection with, or during
            negotiations of, any merger, sale of company assets, financing, or
            acquisition of all or a portion of our business to another company.
            5. Do we use cookies and other tracking technologies? At this moment
            we do not use cookies and other tracking technologies to collect and
            store your information but we may use it in the future. 6. Is your
            information transferred internationally? We may transfer, store, and
            process your information in countries other than your own. Our
            servers are located in the United States and in Poland. If you are
            accessing our Services, please be aware that your information may be
            transferred to, stored, and processed by us in our facilities and by
            those third parties with whom we may share your personal
            information.. If you are a resident in the European Economic Area
            (EEA) or United Kingdom (UK), then these countries may not
            necessarily have data protection laws or other similar laws as
            comprehensive as those in your country. However, we will take all
            necessary measures to protect your personal information in
            accordance with this privacy notice and applicable law. European
            Commission's Standard Contractual Clauses: We have implemented
            measures to protect your personal information, including by using
            the European Commission's Standard Contractual Clauses for transfers
            of personal information between our group companies and between us
            and our third-party providers. These clauses require all recipients
            to protect all personal information that they process originating
            from the EEA or UK in accordance with European data protection laws
            and regulations. Our Standard Contractual Clauses can be provided
            upon request. We have implemented similar appropriate safeguards
            with our third-party service providers and partners and further
            details can be provided upon request. 7. How long do we keep your
            information? We keep your information for as long as necessary to
            fulfill the purposes outlined in this privacy notice unless
            otherwise required by law. We will only keep your personal
            information for as long as it is necessary for the purposes set out
            in this privacy notice, unless a longer retention period is required
            or permitted by law (such as tax, accounting, or other legal
            requirements). When we have no ongoing legitimate business need to
            process your personal information, we will either delete or
            anonymize such information, or, if this is not possible (for
            example, because your personal information has been stored in backup
            archives), then we will securely store your personal information and
            isolate it from any further processing until deletion is possible.
            8. How do we keep your information safe? We aim to protect your
            personal information through a system of organizational and
            technical security measures. We have implemented appropriate and
            reasonable technical and organizational security measures designed
            to protect the security of any personal information we process.
            However, despite our safeguards and efforts to secure your
            information, no electronic transmission over the Internet or
            information storage technology can be guaranteed to be 100% secure,
            so we cannot promise or guarantee that hackers, cybercriminals, or
            other unauthorized third parties will not be able to defeat our
            security and improperly collect, access, steal, or modify your
            information. Although we will do our best to protect your personal
            information, transmission of personal information to and from our
            Services is at your own risk. You should only access the Services
            within a secure environment. 9. Do we collect information from
            minors? We do not knowingly collect data from or market to children
            under 18 years of age. We do not knowingly solicit data from or
            market to children under 18 years of age. By using the Services, you
            represent that you are at least 18 or that you are the parent or
            guardian of such a minor and consent to such minor dependent's use
            of the Services. If we learn that personal information from users
            less than 18 years of age has been collected, we will delete such
            data from our records. If you become aware of any data we may have
            collected from children under age 18, please contact us at
            hello@cognitiva.dev 10. What are your privacy rights? In some
            regions, such as the European Economic Area (EEA), United Kingdom
            (UK), and Canada, you have rights that allow you greater access to
            and control over your personal information. In some regions (like
            the EEA, UK, and Canada), you have certain rights under applicable
            data protection laws. These may include the right (i) to request
            access and obtain a copy of your personal information, (ii) to
            request rectification or erasure; (iii) to restrict the processing
            of your personal information; and (iv) if applicable, to data
            portability. In certain circumstances, you may also have the right
            to object to the processing of your personal information. You can
            make such a request by contacting us by using the contact details.
            We will consider and act upon any request in accordance with
            applicable data protection laws. If you are located in the EEA or UK
            and you believe we are unlawfully processing your personal
            information, you also have the right to complain to your local data
            protection supervisory authority. You can find their contact details
            here:
            https://ec.europa.eu/justice/data-protection/bodies/authorities/index
            en.htm. If you are located in Switzerland, the contact details for
            the data protection authorities are available here:
            https://www.edoeb.admin.ch/edoeb/en/home.html. Withdrawing your
            consent: If we are relying on your consent to process your personal
            information, which may be express and/or implied consent depending
            on the applicable law, you have the right to withdraw your consent
            at any time. You can withdraw your consent at any time by contacting
            us by using the contact details. However, please note that this will
            not affect the lawfulness of the processing before its withdrawal,
            nor when applicable law allows, will it affect the processing of
            your personal information conducted in reliance on lawful processing
            grounds other than consent. 11. Controls for do-not-track-features
            Most web browsers and some mobile operating systems and mobile
            applications include a Do-Not-Track ("DNT") feature or setting you
            can activate to signal your privacy preference not to have data
            about your online browsing activities monitored and collected. At
            this stage no uniform technology standard for recognizing and
            implementing DNT signals has been finalized. As such, we do not
            currently respond to DNT browser signals or any other mechanism that
            automatically communicates your choice not to be tracked online. If
            a standard for online tracking is adopted that we must follow in the
            future, we will inform you about that practice in a revised version
            of this privacy notice. We may also collect other personal
            information outside of these categories instances where you interact
            with us in person, online, or by phone or mail in the context of:
            Receiving help through our customer support channels; Participation
            in customer surveys or contests; and Facilitation in the delivery of
            our Services and to respond to your inquiries. If you are using an
            authorized agent to exercise your right to opt out we may deny a
            request if the authorized agent does not submit proof that they have
            been validly authorized to act on your behalf.You may contact us by
            email at hello@cognitiva.dev, or by referring to the contact details
            at the bottom of this document. 12. Will your information be shared
            with anyone else? We may disclose your personal information with our
            service providers pursuant to a written contract between us and each
            service provider. Each service provider is a for-profit entity that
            processes the information on our behalf. We may use your personal
            information for our own business purposes, such as for undertaking
            internal research for technological development and demonstration.
            This is not considered to be "selling" of your personal information.
            Cognitiva Sp. z o.o.. has not sold any personal information to third
            parties for a business or commercial purpose in the preceding twelve
            (12) months. Cognitiva Sp. z o.o. has disclosed the following
            categories of personal information to third parties for a business
            or commercial purpose in the preceding twelve (12) months: Category
            A. Identifiers, such as contact details like your real name, alias,
            postal address, telephone or mobile contact number, unique personal
            identifier, online identifier, Internet Protocol address and email
            address. Category B. Personal information, as defined in the
            California Customer Records law, such as your name, contact
            information, education, employment, employment history, and
            financial information. Category F. Internet or other electronic
            network activity information, such as browsing history, search
            history, online behavior, interest data, and interactions with our
            and other websites, applications, systems, and advertisements.
            Category G. Geolocation data, such as device location. Your rights
            with respect to your personal data Right to request deletion of the
            data — Request to delete You can ask for the deletion of your
            personal information. If you ask us to delete your personal
            information, we will respect your request and delete your personal
            information, subject to certain exceptions provided by law, such as
            (but not limited to) the exercise by another consumer of his or her
            right to free speech, our compliance requirements resulting from a
            legal obligation, or any processing that may be required to protect
            against illegal activities. Right to be informed — Request to know
            Depending on the circumstances, you have a right to know: whether we
            collect and use your personal information; the categories of
            personal information that we collect; the purposes for which the
            collected personal information is used; whether we sell your
            personal information to third parties; the categories of personal
            information that we sold or disclosed for a business purpose; the
            categories of third parties to whom the personal information was
            sold or disclosed for a business purpose; and the business or
            commercial purpose for collecting or selling personal information.
            In accordance with applicable law, we are not obligated to provide
            or delete consumer information that is de-identified in response to
            a consumer request or to re-identify individual data to verify a
            consumer request. Right to Non-Discrimination for the Exercise of a
            Consumer's Privacy Rights We will not discriminate against you if
            you exercise your privacy rights. To exercise these rights, you can
            contact us by email at hello@cognitiva.dev or by referring to the
            contact details at the bottom of this document. If you have a
            complaint about how we handle your data, we would like to hear from
            you. Verification process Upon receiving your request, we will need
            to verify your identity to determine you are the same person about
            whom we have the information in our system. These verification
            efforts require us to ask you to provide information so that we can
            match it with information you have previously provided us. For
            instance, depending on the type of request you submit, we may ask
            you to provide certain information so that we can match the
            information you provide with the information we already have on
            file, or we may contact you through a communication method (e.g.,
            phone or email) that you have previously provided to us. We may also
            use other verification methods as the circumstances dictate. We will
            only use personal information provided in your request to verify
            your identity or authority to make the request. To the extent
            possible, we will avoid requesting additional information from you
            for the purposes of verification. However, if we cannot verify your
            identity from the information already maintained by us, we may
            request that you provide additional information for the purposes of
            verifying your identity and for security or fraud-prevention
            purposes. We will delete such additionally provided information as
            soon as we finish verifying you. Other privacy rights You may object
            to the processing of your personal information. You may request
            correction of your personal data if it is incorrect or no longer
            relevant, or ask to restrict the processing of the information. You
            may request to opt out from future selling of your personal
            information to third parties. Upon receiving an opt-out request, we
            will act upon the request as soon as feasibly possible, but no later
            than fifteen (15) days from the date of the request submission. To
            exercise these rights, you can contact us by email at
            hello@cognitiva.dev, or by referring to the contact details at the
            bottom of this document. If you have a complaint about how we handle
            your data, we would like to hear from you. 13. Do we make updates to
            this notice? Yes, we will update this notice as necessary to stay
            compliant with relevant laws. We may update this privacy notice from
            time to time. The updated version will be indicated by an updated
            "Revised" date and the updated version will be effective as soon as
            it is accessible. If we make material changes to this privacy
            notice, we may notify you either by prominently posting a notice of
            such changes or by directly sending you a notification. We encourage
            you to review this privacy notice frequently to be informed of how
            we are protecting your information. 14. How can you review, update,
            or delete the data we collect from you? Based on the applicable laws
            of your country, you may have the right to request access to the
            personal information we collect from you, change that information,
            or delete it. To request to review, update, or delete your personal
            information, you can contact us by email at hello@cognitiva.dev 15.
            How can you contact us about this notice? If you have questions or
            comments about this notice, you may email us at hello@cognitiva.dev
            or by post to: Cognitiva Sp. z o.o. Pulawska 472, Warsaw Poland
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
